// react
import { useContext, useEffect, useState } from "react";

// context
import ProductContext from "../../context/ProductContext";

// components
import { Heading } from "../heading/Heading";
import NonBreakingSpace from "../nonbreakingSpace/NonBreakingSpace";

// styles
import "./pricingAvailability.styles.scss";

export enum AvailabilityOption {
  Pricing,
  Availability,
  NoResult,
  Discontinued,
  NoCatalogs,
  ComingSoon,
}

interface PriceAvailablityProps {
  children: any;
  availabilityOption: AvailabilityOption;
}

const PricingAvailability = (
  { children, availabilityOption }: PriceAvailablityProps,
  props: any,
) => {
  const context: any = useContext(ProductContext);

  const { Pricing, Availability, NoResult, Discontinued, NoCatalogs } =
    AvailabilityOption;

  const {
    productState: { ProductNumber },
  }: {
    productState: {
      ProductNumber: string;
    };
  } = context;

  const [localProductNumber, setProductNumber] = useState(ProductNumber);

  const beforeProductNumberMsg = () => {
    switch (availabilityOption) {
      case Pricing:
        return `Pricing`;
      case Availability:
        return `Availability`;
      case NoResult:
        return `There are no results for`;
      case NoCatalogs:
        return `Sorry, we are unable to look up inventory details for`;
      default:
        return "";
    }
  };

  const afterProductNumberMsg = () => {
    switch (availabilityOption) {
      case Discontinued:
        return `has been discontinued.`;
      default:
        return ``;
    }
  };

  useEffect(() => {
    setProductNumber(ProductNumber);
  }, [ProductNumber]);

  return (
    <>
      {localProductNumber && (
        <div
          className={`${
            availabilityOption === Discontinued
              ? "_availability_component_content_table"
              : "pricingAvailability"
          }`}
        >
          <Heading
            className={"pricingAvailability_lineBreak hdg hdg_h4 hdg_neutral"}
            element="h4"
            {...props}
          >
            <span>
              {availabilityOption === NoResult && (
                <span className="material-icons">info</span>
              )}
              {availabilityOption === NoCatalogs && (
                <span className="material-icons">info</span>
              )}
              {availabilityOption === Discontinued && (
                <span className="material-icons">report_problem</span>
              )}
              {beforeProductNumberMsg()}
              {(availabilityOption === NoResult ||
                availabilityOption === NoCatalogs ||
                availabilityOption === Discontinued) && (
                <span className={"pricingAvailability-link"}>
                  {localProductNumber.toUpperCase()}
                </span>
              )}
              {availabilityOption === Discontinued && <NonBreakingSpace />}
              {afterProductNumberMsg()}
            </span>
          </Heading>
          {children}
        </div>
      )}
    </>
  );
};

export default PricingAvailability;
